import { render, staticRenderFns } from "./advertise.vue?vue&type=template&id=1ef09d3f&scoped=true&"
import script from "./advertise.vue?vue&type=script&lang=js&"
export * from "./advertise.vue?vue&type=script&lang=js&"
import style0 from "./advertise.vue?vue&type=style&index=0&id=1ef09d3f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef09d3f",
  null
  
)

export default component.exports